import { app } from '../../../app';

app.component('saaspassVpn', {
    bindings:{
        settings:'<',
    },
    templateUrl: require('./saaspass-vpn.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-vpn/saaspass-vpn.component.js